import { render, staticRenderFns } from "./EvaluatedCategories.vue?vue&type=template&id=1ae88ae6&"
import script from "./EvaluatedCategories.vue?vue&type=script&lang=js&"
export * from "./EvaluatedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports